<template>
  <div class="Readily">
    <div class="content">
      <titleStyle title="困难帮扶" :icon="()=>require(`@/assets/template/${$store.getters.moduleName}/input9icon/7.png`)" />
      <component
        :is="path"
        ref="editOrCreate"
        style="background: #fff;"
        :form-type="formType"
        :method-path="methodPath"
        @reFresh="reFresh"
      />
    </div>
  </div>
</template>

<script>
import titleStyle from '@/components/titleStyle/index.vue'
export default {
  components: { titleStyle },
  data() {
    var checkTel = (rule, value, callback) => { // 编辑验证
      const re = /^1[3456789]{1}\d{9}$/
      if (!re.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      }
      callback()
    }
    var options = [{ // 编辑下拉框内容
      options: [{
        value: '一般',
        label: '一般'
      }, {
        value: '困难',
        label: '困难'
      }, {
        value: '特困',
        label: '特困'
      }]
    }]
    return {
      methodPath: { // 接口必传
        create: 'personal/DifficultyPeopleCreateDiff' // 创建接口
      },
      path: () => import('@/components/tableComponent/editOrCreate.vue'), // 编辑页面,如需要自定义可以引用自己的文件
      formType: {
        name: {
          label: '姓名',
          message: '请输姓名'
        },
        tel: { label: '联系电话', validator: checkTel },
        idCardNo: { label: '身份证号', message: '请输入身份证号' },
        address: { label: '家庭地址', message: '请输入家庭地址' },
        lv: { label: '困难程度', type: 'select', options, message: '请选择困难程度' }, // 下拉选择
        remark: { // 富文本
          label: '详细内容',
          type: 'rich'
        }
        // pbId: { // 自定义功能
        //   label: '权限', // 必传
        //   type: 'custom', // 必传
        //   component: () => import('./components/custom.vue'), message: '请输入权限', // 必传,自定义组件的路径
        //   data: { name: 1, age: '需要传入的参数' } // 非必传,这个是想要代入组件的参数
        // }
        // type: { // 单选框
        //   label: '权限',
        //   type: 'deform',
        //   data: { '1': '超级管理员', '2': '支部管理员' } // 必传, key为返回值,value为显示的内容
        // }

      }
    }
  },

  mounted() {

  },
  created() {
  },

  methods: {
    reFresh() {
      this.$go('/personal/DifficultyPeople?selected=3')
    }
  }
}
</script>

<style lang="scss" scoped>
  .Readily{
    background: #f5f9fa;
    flex: 1;
    .content{
      display: flex;
      flex-direction: column;
      width: 1300px;
      background: #fff;
      margin: 0px auto 118px auto;
      padding: 30px 0 87px 32px;
            position: relative;
      top: 20px;
    }
  }
</style>
